/* eslint-disable new-cap */

/**
 * 是否身份证号码
 * @param {string} str 字符串
 * @return {bool}
 */
var util = {
  isIDCard: function isIDCard(str) {
    var C15ToC18 = function C15ToC18(c15) {
      var cId = "".concat(c15.substring(0, 6), "19").concat(c15.substring(6, 15));
      var strJiaoYan = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      var intQuan = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var intTemp = 0;

      for (var i = 0; i < cId.length; i++) {
        intTemp += cId.substring(i, i + 1) * intQuan[i];
      }

      intTemp %= 11;
      cId += strJiaoYan[intTemp];
      return cId;
    };

    var Is18IDCard = function Is18IDCard(IDNum) {
      var aCity = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外'
      };
      var iSum = 0; // const info = '';

      var sID = IDNum;

      if (!/^\d{17}(\d|x)$/i.test(sID)) {
        return false;
      }

      sID = sID.replace(/x$/i, 'a');

      if (aCity[parseInt(sID.substr(0, 2))] == null) {
        return false;
      }

      var sBirthday = "".concat(sID.substr(6, 4), "-").concat(Number(sID.substr(10, 2)), "-").concat(Number(sID.substr(12, 2)));
      var d = new Date(sBirthday.replace(/-/g, '/'));
      if (sBirthday != "".concat(d.getFullYear(), "-").concat(d.getMonth() + 1, "-").concat(d.getDate())) return false;

      for (var i = 17; i >= 0; i--) {
        iSum += Math.pow(2, i) % 11 * parseInt(sID.charAt(17 - i), 11);
      }

      if (iSum % 11 != 1) return false;
      return true;
    };

    return str.length == 15 ? Is18IDCard(C15ToC18(str)) : Is18IDCard(str);
  },

  /**
  * 校验邮箱地址
  * @param {string} str 字符串
  * @return {bool}
  */
  isMail: function isMail(str) {
    return /^(?:[\w-]+\.?)*[\w-]+@(?:[\w-]+\.)+[\w]{2,3}$/.test(str);
  },

  /**
  * 校验普通电话、传真号码：可以“+”开头，除数字外，可含有“-”
  * @param {string} str 字符串
  * @return {bool}
  */
  isTel: function isTel(str) {
    return /^[+]{0,1}(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/.test(str);
  },

  /**
  * 校验手机号码：必须以数字开头
  * @param {string} str 字符串
  * @return {bool}
  */
  isMobilePhone: function isMobilePhone(str) {
    return /^1[3456789]\d{9}$/.test(str);
  },

  /**
  * 校验邮政编码
  * @param {string} str 字符串
  * @return {bool}
  */
  isZipCode: function isZipCode(str) {
    return /^(\d){6}$/.test(str);
  },

  /**
  * 获取字节长度
  * @param {string} str 字符串
  * @return {number}
  */
  getCharLength: function getCharLength(str) {
    var iLength = 0; // 记录字符的字节数

    for (var i = 0; i < str.length; i++) {
      // 遍历字符串中的每个字符
      if (str.charCodeAt(i) > 255) {
        // 如果当前字符的编码大于255
        iLength += 2; // 所占字节数加2
      } else {
        iLength += 1; // 否则所占字节数加1
      }
    }

    return iLength; // 返回字符所占字节数
  },

  /**
  * 按照字节长度切割字符串
  * @param {string} str 待切割字符串
   * @param {number} len 需要的字节长度
  * @return {string}
  */
  splitStringByCharLength: function splitStringByCharLength(str, len) {
    if (!str && typeof str !== 'undefined') {
      return '';
    }

    var num = 0;
    var str1 = str;
    var splitStr = '';

    for (var i = 0, lens = str1.length; i < lens; i++) {
      num += str1.charCodeAt(i) > 255 ? 2 : 1;

      if (num > len) {
        break;
      } else {
        splitStr = str1.substring(0, i + 1);
      }
    }

    return splitStr;
  }
};
export default util;